import { themed } from '../../../themer';
import { IStyledHeaderProps } from '../IStyledHeaderProps';

export const getTextColor = themed<IStyledHeaderProps>(
	({ color }, { inverted }) =>
		inverted ? color.text.inverted : color.text.default,
);
